var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 29,
    viewBox: "0 0 17 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_292_28665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9746 16.2628C4.87291 16.2628 2.63586 16.2628 1.61902 16.2628C1.0767 16.2628 0.907227 16.0595 0.907227 15.5511C0.907227 14.1953 0.907227 12.8056 0.907227 11.4498C0.907227 10.9075 1.1106 10.738 1.61902 10.738H4.9746C4.9746 10.6363 4.9746 8.67042 4.9746 7.75527C4.9746 6.39948 5.21186 5.11148 5.88975 3.92516C6.60154 2.70495 7.61838 1.89148 8.90638 1.41695C9.75375 1.1119 10.6011 0.976318 11.5163 0.976318H14.838C15.3125 0.976318 15.5159 1.17969 15.5159 1.65421V5.51821C15.5159 5.99274 15.3125 6.19611 14.838 6.19611C13.9228 6.19611 13.0076 6.19611 12.0925 6.23C11.1773 6.23 10.7028 6.67063 10.7028 7.61969C10.6689 8.63653 10.7028 9.61948 10.7028 10.6702H14.6346C15.1769 10.6702 15.3803 10.8736 15.3803 11.4159V15.5172C15.3803 16.0595 15.2108 16.229 14.6346 16.229C13.4144 16.229 10.8045 16.229 10.7028 16.229V27.2786C10.7028 27.8548 10.5333 28.0582 9.92323 28.0582C8.49965 28.0582 7.10996 28.0582 5.68638 28.0582C5.17796 28.0582 4.9746 27.8548 4.9746 27.3464C4.9746 23.7875 4.9746 16.3645 4.9746 16.2628Z",
    fill: "#ED3E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_292_28665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.2105,
    height: 28,
    fill: "white",
    transform: "translate(0.123047 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.cc4778e42f7f3d75fea8c81966b391f4.svg";
export { ForwardRef as ReactComponent };